import {
    Component,
    inject,
    Injectable,
    signal,
} from "@angular/core";

import {
    MatDialog,
    MatDialogRef,
    MAT_DIALOG_DATA
} from "@angular/material/dialog";

import {
    lastValueFrom
} from "rxjs";

import {
    downloadFile
} from 'src/app/shared/data-conversion-utils';

import {
    Customers,
    Sales,
    Items
} from "tilby-models";

import {
    TilbyDialogContentComponent,
    TilbyDialogToolbarComponent
} from "@tilby/tilby-ui-lib/components/tilby-dialog";

import {
    BaseDialogService,
    NonNullableConfigData
} from "@tilby/tilby-ui-lib/components/tilby-dialog";
    
import {
    TranslateModule
} from "@ngx-translate/core";

import {
    NgxJsonViewerModule
} from "ngx-json-viewer";

export type GenericJsonDialogData = { title?: string; nameFile?: string, json: Customers | Sales | Items | undefined };

@Component({
    standalone: true,
    selector: 'app-generic-json-detail-dialog',
    templateUrl: './generic-json-detail-dialog.component.html',
    imports: [
        TilbyDialogToolbarComponent,
        TilbyDialogContentComponent,
        TranslateModule,
        NgxJsonViewerModule
    ]
})
class GenericJsonDetailDialogComponent {
    private readonly dialogRef: MatDialogRef<GenericJsonDetailDialogComponent> = inject(MatDialogRef);
    public readonly data: GenericJsonDialogData = inject(MAT_DIALOG_DATA);

    protected customActions = [
        {
            isIt: signal(true),
            name: '',
            icon: signal('content_copy'),
            click: () => this.copyToClipboard()
        },
        {
            isIt: signal(true),
            name: '',
            icon: signal('file_download'),
            click: () => this.saveFile()
        }
    ];
    

    get dataObj() {
        return this.data.json;
    }

    cancel() {
        this.dialogRef.close({ cancel: true });
    };

    copyToClipboard() {
        navigator.clipboard.writeText(JSON.stringify(this.data.json, null, 2));
    }

    saveFile() {
        let fileName = this.data.json?.id ? (`${this.data.nameFile}_id_${this.data.json.id}`) : this.data.nameFile;
        let content: string | Blob = JSON.stringify(this.data.json, null, 2);
        let mime, extension;

        mime = 'application/json';
        extension = 'json';

        downloadFile(content, `${fileName}${extension ? `.${extension}` : ''}`, mime);
    }
}

@Injectable({
    providedIn: 'root',
})
export class GenericJsonDetailDialogService extends BaseDialogService {
    private readonly dialog = inject(MatDialog);

    public openDialog(options: NonNullableConfigData<GenericJsonDialogData>): Promise<any> {
        const config: NonNullableConfigData<GenericJsonDialogData> = {
            ...this.switchMobileDesktopDimensions({ width: '60vh' }),
            ...options,
        };

        return lastValueFrom(
            this.dialog.open(GenericJsonDetailDialogComponent, config).afterClosed()
        );
    }
}
